import type { AppModules } from "@vintecc/capture-api-types/v1";

import { useAppStore } from "@/store/appStore";

export const APP_BACKGROUND_COLORS: string[] = [
  "#457B9D", // Cool Blue
  "#8A5A83", // Plum Purple
  "#D5A021", // Golden Brown
  "#2B2D42", // Charcoal Gray
  "#264653", // Deep Slate Blue
  "#E9C46A", // Mustard Yellow
  "#2A9D8F", // Soft Teal
  "#F4A261", // Warm Orange
  "#E76F51", // Coral Red
  "#1D3557", // Dark Indigo
] as const;

export const getModuleRights = (moduleName: string, customRights?: AppModules[]) => {
  const rights = customRights || useAppStore.getState().loginAnswer?.rights || [];
  const app = rights.find((r) => r.modules?.some((m) => m.module === moduleName));

  return (
    app?.modules?.find((m) => m.module === moduleName) || {
      view: false,
      manage: false,
    }
  );
};
